import { Components } from '@sunrise/types'
import { Ref, onMounted, ref } from 'vue'

const findScrollableParent = ({ parentElement }: HTMLElement): HTMLElement | null => {
    if (!parentElement) {
        return null
    }
    const overflow = getComputedStyle(parentElement).overflow
    if (overflow && overflow !== 'visible') {
        return parentElement
    }

    return findScrollableParent(parentElement)
}

const getDirection = (scrollable: HTMLElement, element: HTMLElement) => {
    const elementMiddleH = element.clientWidth / 2 + element.getBoundingClientRect().x
    const scrollableMiddleH = scrollable.clientWidth / 2 + scrollable.getBoundingClientRect().x

    if (elementMiddleH > scrollableMiddleH) {
        return Components.CsTooltip.TooltipPosition.Left
    } else {
        return Components.CsTooltip.TooltipPosition.Right
    }
}

export const useDynamicTooltipPosition = (amsTooltipPopover: Ref<HTMLElement | undefined>) => {
    const localPosition = ref<Components.CsTooltip.TooltipPosition>()

    onMounted(() => {
        const $el = amsTooltipPopover.value
        if (!$el) {
            return
        }

        const scrollable = findScrollableParent($el)

        if (!(scrollable instanceof HTMLElement)) {
            return
        }

        const updateLocalPosition = () => {
            localPosition.value = getDirection(scrollable, $el)
        }

        scrollable.addEventListener('scroll', updateLocalPosition)

        updateLocalPosition()
    })

    return localPosition
}
